<template>
  <a :href="category.url" :title="category.name">
    <figure class="image is-square">
      <responsive-image :desktop="category.desktop_image" :tablet="category.tablet_image" :mobile="category.mobile_image" :blurred="category.blurred_image" lazy/>
      <div class="overlay">
        <h1 class="title">
          {{category.name}}
        </h1>
      </div>
    </figure>
  </a>
</template>

<script>
import ResponsiveImage from '../ResponsiveImage.vue'

export default {
  props: {
    category: {type: Object, default: () => ({})}
  },

  components: {
    ResponsiveImage
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/category/Preview.vue